import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import * as queryString from 'query-string';
import { connect } from 'react-redux';

import { setAuthHeader, setAuthUser } from '../../actions';
import { addRecepient, setNewConv } from '../../actions/messaging-actions';

import Inbox from '../Inbox';

const WebViewMessaging = (props) => {
    const parsed = queryString.parse(props.location.search);
    const { jwt, ispower = false, rid, rname } = parsed;
    console.log('jwt', jwt);
    props.setAuthHeader({ jwt });

    const [userId, setUserId] = useState();

    // recepient { memberId, displayName }

    useEffect(() => {
        console.log('useEffect userId', props.match.params.userId);
        setUserId(props.match.params.userId);
        props.setAuthUser({ id: props.match.params.userId, isPowered: ispower });
        if (rid && rname) {
            props.setNewConv(true);
            props.addRecepient({
                member: {
                    memberId: rid,
                    displayName: decodeURI(rname),
                },
            });
        }
    }, []);

    // useEffect(() => {
    //     const setVhVar = debounce(() => {
    //         const vh = window.innerHeight * 0.01;
    //         document.documentElement.style.setProperty('--vh', `${vh}px`);
    //     }, 100);

    //     window.addEventListener('resize', setVhVar);

    //     return () => {
    //         window.removeEventListener('resize', setVhVar);
    //     };
    // }, []);

    return userId ? (
        <Inbox {...props} data-testid="webview.messaging.inbox" />
    ) : null;
};

const mapDispatchToProps = {
    setAuthHeader,
    setAuthUser,
    setNewConv,
    addRecepient,
};

export default withRouter(connect(null, mapDispatchToProps)(WebViewMessaging));
